(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBackgroundColorScheme = this.getAttribute('data-background-color-scheme');
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
		//this.throttledScrollHandler = throttle(this.onScrollHandler, 300);

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
      }

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.classList.remove('color-background-2');
		this.header.style.transition = 'background var(--duration-short)';
		this.header.style.transform = 'translateY(0)';
      }

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
        if (this.header.classList.contains(this.headerBackgroundColorScheme)) {
		this.header.classList.add('color-background-2');
        }
      }

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;		
      if (document.querySelector('.overflow-hidden-tablet')) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		if (document.querySelector('.entering-section')) {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
      } else {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden','color-background-2');
		}
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (this.header.classList.contains(this.headerBackgroundColorScheme)) {
			this.header.classList.add('color-background-2');
      }
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
        this.disclosures.forEach((disclosure) => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
        this.disclosureLists.forEach((disclosureList) => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  //class CartNote extends HTMLElement {
  //  constructor() {
  //    super();

  //    this.addEventListener(
  //      'change',
  //      debounce((event) => {
  //        const body = JSON.stringify({ note: event.target.value });
  //        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  //      }, 300)
  //    );
  //  }
  //}

  //customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();

      this.isProductPage = true;
      this.visibleMediaObserver = null;
      this.visibleMediaRatios = new Map();
      this.activeVisibleMedia = null;
    }

    hide() {
      this.teardownVisibleMediaAutoplay();
      super.hide(this.isProductPage);
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
      this.setupVisibleMediaAutoplay();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      if (activeMedia) {
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
      }
      if (
        activeMedia?.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia?.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }

    isVideoAutoplayEnabled() {
      return this.dataset.enableVideoAutoplay === 'true';
    }

    setupVisibleMediaAutoplay() {
      this.teardownVisibleMediaAutoplay();

      if (!this.isVideoAutoplayEnabled()) return;

      const dialog = this.querySelector('.product-media-modal__dialog');
      const mediaItems = Array.from(this.querySelectorAll('.product-media-modal__item')).filter((item) =>
        item.querySelector('deferred-media')
      );

      if (!dialog || !mediaItems.length) return;

      this.visibleMediaObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.visibleMediaRatios.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
          });

          this.syncVisibleMediaPlayback();
        },
        {
          root: dialog,
          threshold: [0, 0.35, 0.6, 0.85],
        }
      );

      mediaItems.forEach((item) => {
        this.visibleMediaRatios.set(item, 0);
        this.visibleMediaObserver.observe(item);
      });

      requestAnimationFrame(() => this.syncVisibleMediaPlayback());
    }

    syncVisibleMediaPlayback() {
      if (!this.isVideoAutoplayEnabled()) return;

      let nextActiveMedia = null;
      let maxRatio = 0;

      this.visibleMediaRatios.forEach((ratio, item) => {
        if (ratio > maxRatio) {
          maxRatio = ratio;
          nextActiveMedia = item;
        }
      });

      if (maxRatio < 0.35) {
        nextActiveMedia = null;
      }

      if (this.activeVisibleMedia === nextActiveMedia) return;

      window.pauseAllMedia();
      this.activeVisibleMedia = nextActiveMedia;

      if (!nextActiveMedia) return;

      const deferredMedia = nextActiveMedia.querySelector('deferred-media');
      if (deferredMedia) {
        window.playMedia(deferredMedia);
      }
    }

    teardownVisibleMediaAutoplay() {
      this.visibleMediaObserver?.disconnect();
      this.visibleMediaObserver = null;
      this.visibleMediaRatios.clear();
      this.activeVisibleMedia = null;
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
